import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=6cf556f5&scoped=true&"
import script from "./DashboardSection.vue?vue&type=script&lang=js&"
export * from "./DashboardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf556f5",
  null
  
)

export default component.exports